import { animated, easings, useSpring } from '@react-spring/web';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useMeasure } from 'react-use';
import styled from 'styled-components';

import type { unitMapping } from 'lib/style';

const Wrapper = styled(animated.div)`
  position: relative;
  overflow: hidden;
`;
const Gap = styled.div<{ $gap: keyof typeof unitMapping }>`
  display: flex;
  height: calc(var(--unit) * ${({ $gap }) => $gap});
`;

type Props = {
  open?: boolean;
  children: ReactNode;
  className?: string;
  gap?: keyof typeof unitMapping;
};
export const Collapse = ({ open, children, className, gap = 2 }: Props) => {
  const [measurementDiv, { height }] = useMeasure<HTMLDivElement>();
  const [mounted, setMounted] = useState(false);

  const style = useSpring({
    to: {
      opacity: open ? 1 : 0,
      height: open ? height : 0,
    },
    config: {
      easing: open ? easings.easeOutSine : easings.easeInSine,
    },
    immediate: !mounted,
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMounted(true);
    }, 300);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Wrapper className={className} style={style}>
      <div ref={measurementDiv}>
        {!!gap && <Gap $gap={gap} />}
        {children}
      </div>
    </Wrapper>
  );
};
